import React, { useEffect } from "react";
import { useLedger } from "../../DataStore/LedgerContext";
import ActivityLoader from "../Common/ActivityLoader";
import Notification from "../Common/Notification";
import functions from "../../util/functions";
import { Link } from "react-router-dom";

// Reusable Dropdown component
const DropdownMenu = ({handRefresh}) => (
  <div className="btn-actions-pane-right actions-icon-btn">
    <div className="btn-group dropdown">
      <button
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        className="btn-icon btn-icon-only btn btn-link"
      >
        <i className="pe-7s-menu btn-icon-wrapper"></i>
      </button>
      <div className="dropdown-menu-right rm-pointers dropdown-menu-shadow dropdown-menu-hover-link dropdown-menu">
        <h6 className="dropdown-header">Options</h6>
        <button className="dropdown-item" onClick={handRefresh}>
          <i className="dropdown-icon fa fa-refresh"></i> Refresh
        </button>
        <Link to="/transaction-ledger" className="dropdown-item">
          <i className="dropdown-icon fa fa-right-left"></i> View Ledgers
        </Link>
        <Link to="/transaction-journal" className="dropdown-item">
          <i className="dropdown-icon fa fa-book"></i> View Journals
        </Link>
        
      </div>
    </div>
  </div>
);

const RecentTransactions = () => {
  const { recentLedgers, getRecentLedgers } = useLedger();

  useEffect(() => {
    getRecentLedgers();
  }, []);

  const renderTransType = (type) => {
    switch (type) {
      case "1":
        return <span className="badge badge-pill badge-success">Income</span>;
      case "2":
        return <span className="badge badge-pill badge-danger">Expense</span>;
      case "3":
          return <span className="badge badge-pill badge-primary">Asset</span>;
      default:
        return <span className="badge badge-pill badge-warning">Liability</span>;
    }
  }
  

  return (
    <div className="card mb-3">
      <div className="card-header-tab card-header">
        <div className="card-header-title font-size-lg text-capitalize font-weight-normal">
          <i className="header-ico fa fa-clock mr-3 text-muted opacity-6"></i>
          Recent Ledger Entries
        </div>
        <DropdownMenu
            handRefresh={()=>getRecentLedgers(true)}
        />
      </div>
      <div
        className="card-body mh-300 overflow-auto"
        style={{ maxHeight: "300px" }}
      >
        {/* Table */}
        {Array.isArray(recentLedgers) && recentLedgers.length > 0 ? (
          <table className="table table-hover table-striped table-bordered">
            <thead>
              <tr>
                <th>Trans Date</th>
                <th>Payee</th>
                <th>Amount</th>
                <th>Description</th>
                <th>Trans Type</th>
                <th>Account</th>
                <th>Date Recorded</th>
              </tr>
            </thead>
            <tbody>
              {recentLedgers.map((transaction, index) => (
                <tr key={index}>
                  <td>{functions.formatDate(transaction.transaction_date)}</td>
                  <td>{transaction.payee?.title || "N/A"}</td>
                  <td>{functions.numberFormat(transaction.amount)}</td>
                  <td>{transaction.description || "N/A"}</td>
                  <td>{renderTransType(transaction.account.account_category_id)}</td>
                  <td>{transaction.account.account_name || "N/A"}</td>
                  <td>{functions.formatDate(transaction.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : recentLedgers === "404" ? (
          <Notification
            type="light"
            message="No transaction found for this financial year"
            closable={false}
          />
        ) : (
          <ActivityLoader width={20} />
        )}
      </div>
    </div>
  );
};

export default RecentTransactions;
